import { useEffect } from "react";

function ReturnOrder() {
  useEffect(() => {
    // Load Termly script only once
    if (!document.getElementById("termly-jssdk")) {
      const script = document.createElement("script");
      script.id = "termly-jssdk";
      script.src = "https://app.termly.io/embed-policy.min.js";
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="return-wrapper">
      {/* Termly Embed */}
      <div
        name="termly-embed"
        data-id="3bfb1c01-1025-4e29-a372-336f7514640a"
      ></div>
    </div>
  );
}

export default ReturnOrder;
